






























































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { DataApi } from '../models/BajasComerciales.model';
import { fetchBajasComerciales } from '../fetchBajasComerciales';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';

@Component({
  components: {
    DatePicker,
  },
})
export default class TabGeneral extends Vue {
  [x: string]: any;
  @Prop({ required: true, default: {} }) data!: DataApi;
  @Prop({}) esEdicion: boolean;
  @Prop({ default: false, required: false }) bajaFinalizada: boolean;
  @Prop({}) editado: boolean;
  @Prop({}) tramos: any;
  dialogConfirmacionClose: boolean;
  loading: boolean = false;

  readonly loadingService = new LoadingService();
  readonly $snotify: Snotify = null;

  async guardar(val: boolean) {
    this.dialogConfirmacionClose = val;
    await this.actualizarBajasComerciales();
  }

  async actualizarBajasComerciales() {
    this.loading = true;
    this.loadingService.showLoading();
    const self = this;
    return await fetchBajasComerciales({
      endpoint: 'update_bajaComercial',
      body: {
        nombre_baja: this.data.nombre_baja,
        cantidad_equipos: this.data.cantidad_equipos,
        cantidad_perifericos: this.data.cantidad_perifericos,
        tramo_baja_comercial: this.data.tramo_baja_comercial,
        id: this.data.id,
        user_id: JSON.parse(localStorage.getItem('user')).id || '',
      },
    })
      .then(resp => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = resp.data;
        const cod: number = Number(CODIGO_RESPUESTA);
        if (CODIGO_RESPUESTA == '1') {
          self.$snotify.success(MENSAJE_RESPUESTA, { timeout: 3000 });
          self.$emit('close');
        } else {
          self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        }
        return LISTA;
      })
      .catch((err: Error) => {
        if (err instanceof Error && err.message) {
          self.$snotify.error(err.message, { timeout: 3500 });
        } else {
          self.$snotify.error(
            'Ha ocurrido un error inesperado, por favor intente más tarde',
            { timeout: 3500 }
          );
        }
      })
      .finally(() => {
        self.loading = false;
        self.loadingService.hideLoading();
        self.$emit('close');
      });
  }
}
